import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
    return (
        <span>
            <header className="bg-primary text-white text-center py-5">
                <div className="container">
                    <h1 className="display-4">Amanda Calem</h1>
                    <p className="lead">Escritora de libros juveniles e infantiles</p>
                </div>
                <div className="container">
                    <Link to="/">Home</Link>
                    <Link to="/books">Books</Link>
                    <Link to="/contact">Contact</Link>
                </div>
            </header>
        </span>
    );
};

export default Header;